import React, { useMemo } from 'react';
import { formatSnakeCaseToGeneral, ListItem, NotVisibleICount } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { ListItemType, PaginationParams } from '@/common/types';
import { TextWithPointer } from '@/components/elements/TextWithPointer';
import Link from '@/modules/core/components/Link';
import { usePayoutDefinitionQuery } from '@/modules/core/queries';
import { PayoutDefinition } from '@/modules/ProcessingDefinition/ProcessingDefinition.types';

const usePayoutDefinitions = (params?: PaginationParams, isLimitedUse?: boolean) => {
  const { formatedData, isLoading, total } = usePayoutDefinitionQuery(
    params,
    undefined,
    undefined,
    undefined,
    isLimitedUse
  );
  const formatedList = useMemo<ListItem[]>(
    () =>
      formatedData?.map((item: PayoutDefinition) => ({
        id: item.id,
        fields: [
          {
            key: 'name',
            type: ListItemType.Info,
            title: item.name || '',
            link: ROUTES.PROCESSING_DEFINITION,
            flex: 2,
            node: (
              <Link to={ROUTES.PAYOUT_DEFINITION_VIEW_BY_ID(item.id)}>
                <TextWithPointer title={item.name} size="medium" weight="bold" color="textBody">
                  {item.name || ''}
                </TextWithPointer>
              </Link>
            ),
          },
          {
            key: 'serviceCategories',
            type: ListItemType.Node,
            title: item?.categoryTypesStrings?.join(', ') || '',
            flex: 3,
            ellipsisMode: true,
            node: (
              <NotVisibleICount
                options={item?.categoryTypesStrings?.map((name) => ({ key: name, value: name })) || []}
                boxStyle={{ margin: 0 }}
                hiddenBoxStyle={{
                  top: '-3px',
                }}
              />
            ),
          },
          {
            key: 'isLimited',
            type: ListItemType.Text,
            title: item.isLimited ? 'Yes' : 'No',
            flex: 1,
          },
          {
            key: 'organizationType',
            type: ListItemType.Text,
            title: item.organizationType ? formatSnakeCaseToGeneral(item.organizationType) : '',
            flex: 1,
          },
        ],
      })),
    [formatedData]
  );

  return {
    formatedList,
    isLoading,
    total,
  };
};

export default usePayoutDefinitions;
